import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadPeriodos } from '../../store/actions/Periodos';

import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import InputAdornment from '@material-ui/core/InputAdornment';
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import IconButton from '@material-ui/core/IconButton';
import LaunchIcon from '@material-ui/icons/Launch';
import Divider from '@material-ui/core/Divider';
import SearchIcon from '@material-ui/icons/Search';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import CircularProgress from '@material-ui/core/CircularProgress';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import CandidatoService from '../../services/Candidato';
import EscolaService from '../../services/Escola';
import { errors } from '../../services/API';

import keycloak, { handleLogin } from '../../security/keycloak';

import AnosLetivos from '../../forms/AnosLetivos/AnosLetivos';
import DialogUploadMatricula from '../../forms/Dialog/DialogUploadMatricula';
import { DialogConfirm as DialogTrocarEscola } from '../../forms/Dialog/DialogConfirm';
import ButtonsForm from '../../forms/Buttons/ButtonsForm';

import Arquivo from '../../components/Inputs/File/File';
import Title from '../../components/Title/Title';
import Text from '../../components/Inputs/Text/Text';
import Toast from "../../components/Toast/Toast";
import Loading from '../../components/Loading/Loading';
import { ButtonPrimary, ButtonDefault } from "../../components/Button/Button";
import { LinkSimple } from '../../components/Link/Link';

import {
    isBlank,
    isBlankHelperText,
    isMecCodeInvalid,
    isMecCodeHelperText,
} from '../../helper/ValidationHelper';
import { download } from '../../helper/FileHelper';
import { mecCodeMask } from '../../helper/MaskHelper';
import { filterPersistence } from '../../helper/ParseStateHelper';

import {
    isInscricoesAbertas,
    getPeriodoDeInscricaoFormatado,
} from '../../helper/ContextHelper';

import Layout from '../../layouts/private/Private';

const __MECCODE_LENGTH = 8;

export class Form extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.match.params.id,
            escola: {
                inep: '',
                nome: '',
                dependencia: '',
                status: '',
            },
            matricula: null,
            inputEscola: '',
            errors: {
                inep: false,
            },
            helpers: {
                inep: null,
            },
            isNova: false,
            isCandidaturaFinalizada: false,
            isPagamentoEmAndamento: false,
            isDeleteComprovante: false,
            escolaEncontrada: false,
            arquivoConfirmado: false,
            loadingButtonSave: false,
            loading: false,
            loadingSearchEscola: false,
            history: {
                path: null,
                state: null
            }
        };
    }

    setToast = t => this.Toast = t;
    setAnosLetivos = e => this.AnosLetivos = e;
    setArquivo = f => this.Arquivo = f;
    setDialogUploadMatricula = d => this.DialogUploadMatricula = d;
    setDialogTrocarEscola = d => this.DialogTrocarEscola = d;

    loadData = async () => {
        await this.props.loadPeriodos();

        const parseFilters = queryString.parse(this.props.location.search);
        this.setState({ loading: true, history: filterPersistence(this.props.location) });

        if (this.state.id) {
            await CandidatoService.find(this.state.id)
                .then((res) => {
                    this.setState({
                        isCandidaturaFinalizada: res.data.dataFinalizacaoInscricao != null ? true : false,
                        isPagamentoEmAndamento: res.data.pagamentoEmAndamento || false,
                    });

                    if (parseFilters.escola) {
                        this.setState({ isNova: true, escola: { ...this.state, inep: mecCodeMask(parseFilters.escola) } }, () => this.handleSearchEscola());

                    } else if (res.data.escola) {
                        this.setState({
                            escola: {
                                inep: res.data.escola.inep ?? '',
                                nome: res.data.escola.nome ?? '',
                                dependencia: res.data.escola.dependenciaAdministrativa ?? '',
                                status: res.data.escola.status ?? '',
                            },
                            inputEscola: `${res.data.escola.inep} - ${res.data.escola.nome} - ${res.data.escola.dependenciaAdministrativa}`,
                            escolaEncontrada: true,
                        });
                    }

                    if (res.data.matricula) {
                        this.setState({
                            matricula: res.data.matricula,
                            isDeleteComprovante: !res.data.matricula.validacao.valido && res.data.matricula.validacao.status === 'INVALIDO' ? true : false,
                        });
                    }

                    this.AnosLetivos.setState({
                        anosLetivosSelecionados: res.data.anosLetivos ?? []
                    });

                }).catch(err => {
                    this.Toast.setState({
                        message: {
                            message: "Erro ao carregar dados. " + err.message,
                            type: 'error',
                            open: true
                        }
                    });
                })
                .finally(() => this.setState({ loading: false }));
        }

    }

    componentDidMount() {
        this.loadData();
        window.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter')
            this.handleSearchEscola();
    };

    // INPUTS
    handleChange = async e => {
        this.setState({
            escola: {
                ...this.state.escola,
                [e.target.name]: e.target.name === 'inep' ? mecCodeMask(e.target.value) : e.target.value
            },
            errors: { ...this.state.errors, [e.target.name]: false },
            helpers: { ...this.state.helpers, [e.target.name]: false }
        });
    };

    handleSearchEscola = () => {

        if (this.state.escola.inep.length !== __MECCODE_LENGTH) {
            this.setState({
                errors: { inep: true, },
                helpers: {
                    inep: "Preencha o campo com um Código INEP de 8 Dígitos",
                },
            });
            return
        }

        this.setState({ loadingSearchEscola: true });

        const f = [{ field: "incluirNovas", value: true }];

        if (this.state.escola.inep) f.push({ field: "cdEscola", value: this.state.escola.inep });

        if (f.length > 1) {
            EscolaService.buscarEscolaMirim(f)
                .then(res => {

                    const escola = res.data.content?.[0];

                    if (escola) {
                        this.setState({
                            escola: {
                                inep: mecCodeMask(escola.cdMecEscola),
                                nome: escola.nmEscola,
                                dependencia: escola.nmDependenciaAdministrativa,
                                status: escola.nmStatus,
                            },
                            inputEscola: `${mecCodeMask(escola.cdMecEscola)} - ${escola.nmEscola} - ${escola.nmDependenciaAdministrativa}`,
                            escolaEncontrada: true,
                            errors: { inep: false },
                            helpers: { inep: false }
                        });
                    } else {
                        this.setState({
                            escola: {
                                inep: '',
                                nome: '',
                                dependencia: '',
                                status: '',
                            },
                            errors: {
                                inep: true,
                            },
                            helpers: {
                                inep: (
                                    <span>
                                        Se sua escola não está cadastrada na nossa base de dados,{' '}
                                        <LinkSimple link={`${process.env.REACT_APP_PUBLIC_MIRIM_URL}/escola/nova?back=${encodeURIComponent(window.location.href)}`}>
                                            clique aqui
                                        </LinkSimple>
                                        {' '}para cadastrar a escola.
                                    </span>
                                ),
                            },
                            escolaEncontrada: false,
                        });

                        this.Toast.setState({
                            message: {
                                message: "Escola não encontrada.",
                                type: "warning",
                                open: true
                            }
                        });
                    }
                })
                .catch(err => {
                    this.Toast.setState({
                        message: {
                            message: "Não Foi Possível Buscar a Escola.",
                            type: 'error',
                            open: true
                        }
                    })
                })
                .finally(() => this.setState({ loadingSearchEscola: false }))
        }
    };

    isValid = () => {

        const inep = this.state.escola.inep;
        const temDocumento = !!this.state.matricula?.id;
        const temNovoArquivo = !!this.Arquivo.state.file;
        const querRemover = this.state.isDeleteComprovante;

        const mecInvalid = isBlank(inep) || isMecCodeInvalid(inep) || !this.state.escolaEncontrada;

        if (mecInvalid) {
            this.setState({
                errors: {
                    inep: mecInvalid,
                },
                helpers: {
                    inep: isBlank(inep) ? isBlankHelperText() : isMecCodeInvalid(inep)
                        ? isMecCodeHelperText() : !this.state.escolaEncontrada
                            ? 'Pesquise o código INEP na lupa.' : isBlankHelperText()
                }
            });
            return false;

        } else if (this.state.escola.status === 'INVALIDA') {

            this.Toast.setState({
                message: {
                    message: "A escola não pode ser selecionada, pesquise por outra escola ou cadastre uma nova escola.",
                    type: "error",
                    open: true
                }
            });

            this.setState({ loadingButtonSave: false });
            return false;

        } else if (temDocumento && querRemover && !temNovoArquivo) {

            this.Toast.setState({
                message: {
                    message: "Selecione um novo arquivo antes de salvar.",
                    type: "warning",
                    open: true
                }
            });

            this.setState({ loadingButtonSave: false });
            return false;
        }

        return true;
    };

    handleSubmit = async () => {
        this.setState({ loadingButtonSave: true });

        const temDocumento = !!this.state.matricula?.id;
        const temNovoArquivo = !!this.Arquivo.state.file;
        const querRemover = this.state.isDeleteComprovante;

        const subindoPelaPrimeiraVez = !temDocumento && temNovoArquivo;
        const atualizandoSemTrocarArquivo = temDocumento && !querRemover;
        const removendoESubindoNovamente = temDocumento && querRemover && temNovoArquivo;

        if (!this.isValid() || !this.AnosLetivos.isValid() || ((!temDocumento || temNovoArquivo) && !this.Arquivo.isValid())) {
            this.setState({ loadingButtonSave: false });
            return;
        }

        if (temNovoArquivo && !this.state.arquivoConfirmado) {
            this.Toast.setState({
                message: {
                    message: "Confirme o documento antes de continuar.",
                    type: "warning",
                    open: true
                }
            });

            this.setState({ loadingButtonSave: false });
            return;
        }

        const formData = new FormData();
        formData.append("inep", this.state.escola.inep);
        this.AnosLetivos.state.anosLetivosSelecionados.forEach(anoLetivo => {
            formData.append('anosLetivos', anoLetivo);
        });

        if (subindoPelaPrimeiraVez || removendoESubindoNovamente) {
            formData.append("matricula", this.Arquivo.state.file);
        }

        if (subindoPelaPrimeiraVez || atualizandoSemTrocarArquivo) {

            this.requestAtualizarEscola(formData);

        } else if (removendoESubindoNovamente) {

            try {

                await this.requestAtualizarEscola(formData, true);

                await CandidatoService.removerDocumento(this.state.id, this.state.matricula.id).then(() => {
                    this.setState({ isDeleteComprovante: false });
                });
                
                this.loadData();
                setTimeout(() => !keycloak.authenticated ? handleLogin(`${process.env.REACT_APP_PUBLIC_URL}/admin/inicial`) : this.handleBack(), 2000);

            } catch (err) {
                this.setState({ loadingButtonSave: false });
            }
        }
    };

    requestAtualizarEscola = async (formData, aguardarProximoPasso = false) => {

        const config = { headers: { 'content-type': 'multipart/form-data' } }

        return await CandidatoService.atualizarEscolaMatricula(this.state.id, formData, config)
            .then(() => {
                this.Toast.setState({
                    message: {
                        message: "Escola Atualizada com Sucesso.",
                        type: "success",
                        open: true
                    }
                });

                if (!aguardarProximoPasso) {
                    this.loadData();
                    setTimeout(() => !keycloak.authenticated ? handleLogin(`${process.env.REACT_APP_PUBLIC_URL}/admin/inicial`) : this.handleBack(), 2000);
                }

            }).catch(err => {
                this.Toast.setState({
                    message: {
                        message: "Erro ao salvar dados da escola de atuação.",
                        type: 'error',
                        open: true
                    }
                });

                throw err;

            }).finally(() => {
                if (!aguardarProximoPasso) {
                    this.setState({ loadingButtonSave: false });
                }
            });
    }

    handleFileSelecionado = () => {
        const file = this.Arquivo?.state?.file;

        if (!file) return;

        this.setState({ arquivoConfirmado: false }, () => {
            if (this.DialogUploadMatricula) {
                this.DialogUploadMatricula.open(file);
            }
        });
    };

    handleBack = () => {
        if (this.state.history && this.state.history.path) {
            this.props.history.push({
                pathname: `${this.state.history.path}`,
                state: {
                    history: {
                        state: this.state.history.state
                    }
                }
            });
        } else {
            if (this.state.isNova) {
                this.props.history.push(`/admin/inicio`);
            } else {
                this.props.history.goBack();
            }
        }
    };

    handleConfirmUpload = (file) => {
        this.setState({
            arquivoConfirmado: true
        });

        if (this.Arquivo) {
            this.Arquivo.setState({ file });
        }
    };

    handleCancelUpload = () => {
        this.setState({ arquivoConfirmado: false });

        if (this.Arquivo) {
            this.Arquivo.setState({
                file: null,
                errors: { file: false },
                helpers: { file: null }
            });
        }
    };

    handleOpenModalTrocarEscola = () => {
        this.DialogTrocarEscola.setState({
            dialog: {
                open: true,
                title: `Confirma a exclusão deste INEP como Escola de Atuação ?`,
                text: `A ação removerá o documento comprovante de vínculo com a escola sendo necessário anexar um novo documento.`,
                loading: false,
                showConfirm: true,
            }
        });
    };

    handleDialogTrocarEscolaConfirm = () => {
        this.setState({
            escola: {
                inep: '',
                nome: '',
                dependencia: '',
                status: this.state.escola.status === 'INVALIDA' ? 'INVALIDA' : '',
            },
            errors: { inep: false },
            helpers: { inep: false },
            escolaEncontrada: false,
            isDeleteComprovante: true,
        })
        this.DialogTrocarEscola.close();
    };

    downloadComprovanteMatricula = (documentoId) => {
        this.Toast.setState({
            message: {
                message: "Em Instantes o Download Iniciará Automáticamente",
                type: "info",
                open: true
            }
        });

        CandidatoService.downloadDocumento(this.state.id, documentoId)
            .then(res => download(res))
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                })
            });
    }

    renderUploadArquivo = () => (
        <Grid item sm={12} lg={12}>
            <Grid item sm={12} lg={10}>
                <Paper elevation={3} style={{ padding: 24, marginBottom: 20 }}>
                    <Grid item sm={12} lg={12} style={{ marginBottom: 10 }}>
                        <Typography variant="body2">
                            - O Comprovante de Matrícula ou Declaração de Vínculo é um documento oficial que comprova seu vínculo como professor na escola selecionada por você na ficha de inscrição.<br />
                            - Para anexar o documento clique no botão <b>SELECIONAR ARQUIVO</b>.<br />
                            - O documento será encaminhado para a Central da OBMEP e o resultado da análise será enviado para o e-mail cadastrado.
                        </Typography>
                    </Grid>
                </Paper>
            </Grid>
            <Grid item lg={9}>
                <Arquivo
                    parentRef={this.setArquivo}
                    handleChange={this.handleFileSelecionado}
                    accept=".pdf, .jpg, .jpeg, .png"
                />
            </Grid>
        </Grid>
    );

    renderBotaoDonwload = () => (
        <Grid item sm={12} xl={10} >
            <ButtonPrimary
                startIcon={<GetAppOutlinedIcon />}
                onClick={() => this.downloadComprovanteMatricula(this.state.matricula.id)}
                name="Download do Comprovante de Matrícula"
                style={{ marginTop: 15, backgroundColor: '#0BA251' }}
            />
        </Grid>
    );

    render() {

        const page = this.state.escola.inep ? 'Editar Escola de Atuação' : 'Informar Escola de Atuação';
        const periodoInscricoes = getPeriodoDeInscricaoFormatado(this.props.contexts);

        const isPagamentoEmAndamento = this.state.isPagamentoEmAndamento;

        const isPodeEditarDados = isInscricoesAbertas(this.props.contexts) && !this.state.isCandidaturaFinalizada && !isPagamentoEmAndamento;

        const { matricula, isDeleteComprovante } = this.state;

        const validacao = matricula?.validacao;

        const temDocumento = !!matricula;
        const isValido = validacao?.valido;
        const isInvalido = validacao?.invalido;
        const isAguardando = validacao?.aguardando;
        const isEmTratamento = temDocumento && !isAguardando && !isValido && !isInvalido;

        const escolaInvalida = this.state.escola.status === 'INVALIDA';
        const escolaEmAnalise = this.state.escola.status === 'EM_ANALISE';

        let conteudo = null;

        if (!temDocumento) {
            conteudo = (
                <>
                    {!isPodeEditarDados ? (
                        <Grid item sm={12} lg={4}>
                            <Alert severity="warning">
                                <>As Inscrições já foram encerradas, portanto, não é mais possível enviar um comprovante de vínculo.</>
                            </Alert>
                        </Grid>
                    ) :
                        this.renderUploadArquivo()
                    }
                </>
            );
        }

        else if (isValido) {
            conteudo = (
                <>
                    <Grid item sm={12} lg={6}>
                        <Alert severity="success">
                            Você realizou o upload deste documento e já foi validado pela OBMEP.
                        </Alert>
                    </Grid>
                    {this.renderBotaoDonwload()}
                </>
            );
        }

        else if (isInvalido) {
            conteudo = (
                <>
                    <Grid item sm={12} lg={6} style={{ marginBottom: 24 }}>
                        <Alert severity="error">
                            O Comprovante de Vínculo com a Escola foi reprovado.

                            {isPodeEditarDados ? (
                                <>
                                    <br /><br />
                                    Por favor, envie outro Comprovante de Vínculo com a Escola dentro do Período de Inscrições (<b>{periodoInscricoes}</b>) para uma nova análise.
                                    <br />
                                    <b>Atenção:</b> Você somente poderá prosseguir com sua inscrição após a validação do documento pela OBMEP.
                                </>
                            ) : (
                                <>
                                    <br /><br />
                                    Não é Possível Enviar um Novo Comprovante de Vínculo com a Escola.
                                </>
                            )}

                            <br /><br />
                            <b>Data:</b> {validacao?.data}<br />
                            <b>Justificativa:</b> {validacao?.justificativa}

                            <Grid item sm={12} xl={12} >
                                <ButtonDefault
                                    startIcon={<GetAppOutlinedIcon />}
                                    onClick={() => this.downloadComprovanteMatricula(matricula.id)}
                                    name="Download do Comprovante de Matrícula"
                                    style={{ marginTop: 15 }}
                                />
                            </Grid>
                        </Alert>
                    </Grid>

                    {isPodeEditarDados && this.renderUploadArquivo()}
                </>
            );
        }

        else if (!isValido && !isInvalido) {
            conteudo = !isDeleteComprovante ? (
                <>
                    <Grid item sm={12} lg={10}>
                        <Alert icon={<AssignmentLateIcon fontSize="inherit" />} severity="warning">
                            Documento foi enviado e será analisado pela equipe da OBMEP.
                        </Alert>
                    </Grid>

                    {this.renderBotaoDonwload()}

                    {isPodeEditarDados && isAguardando && (
                        <ButtonPrimary
                            startIcon={<DeleteForeverIcon />}
                            onClick={() => this.setState({ isDeleteComprovante: true })}
                            name="Excluir Comprovante de Matrícula"
                            style={{ marginTop: 15, backgroundColor: '#e84b3dce' }}
                        />
                    )}
                </>
            ) : (
                <>
                    {isPodeEditarDados && this.renderUploadArquivo()}
                </>
            );
        }

        return (
            <Layout>
                <Toast parentRef={this.setToast} />

                <Title>{page}</Title>

                <Loading show={this.state.loading} />

                <Grid container spacing={3}>
                    <Grid item sm={12} lg={6}>
                        <Alert severity="info">
                            Para salvar as alterações realizadas clique no botão <b>Salvar</b>.
                        </Alert>
                    </Grid>
                </Grid>

                <Grid container spacing={3} style={{ display: this.state.loading ? 'none' : 'flex' }}>
                    <Grid item sm={12} xl={6} >
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs>
                                <Text
                                    required={true}
                                    name="inep"
                                    label="Código MEC/INEP"
                                    value={this.state.escolaEncontrada
                                        ? `${this.state.inputEscola}`
                                        : this.state.escola.inep}
                                    onChange={this.handleChange}
                                    error={this.state.errors.inep}
                                    helperText={this.state.helpers.inep}
                                    disabled={this.state.escolaEncontrada || !isPodeEditarDados || this.state.matricula?.validacao?.valido}
                                    inputProps={{ maxLength: __MECCODE_LENGTH }}
                                    InputProps={{
                                        endAdornment:
                                            <InputAdornment position="end">
                                                {this.state.escolaEncontrada ? (
                                                    <Tooltip title="Limpar Escola" TransitionComponent={Zoom}>
                                                        <IconButton
                                                            size="small"
                                                            color="primary"
                                                            aria-label="Limpar Escola"
                                                            disabled={!isPodeEditarDados || this.state.matricula?.validacao?.valido || (isEmTratamento && !escolaInvalida)}
                                                            onClick={this.handleOpenModalTrocarEscola}
                                                        >
                                                            <ClearOutlinedIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                ) : this.state.loadingSearchEscola ? (
                                                    <CircularProgress size='small' />
                                                ) : (
                                                    <>
                                                        <Tooltip title="Buscar Escola" TransitionComponent={Zoom}>
                                                            <IconButton
                                                                size="small"
                                                                color="primary"
                                                                onClick={this.handleSearchEscola}
                                                            >
                                                                <SearchIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                        |
                                                        <Tooltip title="Ver Lista das Escolas cadastradas na Olimpiada Mirim" TransitionComponent={Zoom}>
                                                            <IconButton
                                                                component="a"
                                                                href={`${process.env.REACT_APP_PUBLIC_MIRIM_URL}/escolas`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                size="small"
                                                            >
                                                                <LaunchIcon style={{ color: '#3f51b5' }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                )}

                                            </InputAdornment>,
                                    }}
                                />
                            </Grid>
                        </Grid>
                        {escolaEmAnalise ?
                            <Grid item sm={12} lg={12}>
                                <Alert severity="warning">
                                    A escola <b>{this.state.inputEscola}</b> está sendo analisada pela equipe da OBMEP.
                                </Alert>
                            </Grid>
                            : escolaInvalida && (
                                <Grid item sm={12} lg={12}>
                                    <Alert severity="error">
                                        A solicitação realizada para cadastrar a nova escola <b>{this.state.inputEscola}</b> no sistema foi <b>reprovada</b>. Clique no ícone <ClearOutlinedIcon size="small" style={{ verticalAlign: 'middle' }} /> {' '} e informe um novo INEP.
                                    </Alert>
                                </Grid>
                            )}
                    </Grid>

                    <Grid item sm={12} xl={12} >
                        <AnosLetivos parentRef={this.setAnosLetivos} disabled={!isPodeEditarDados} />
                    </Grid>

                    <Grid item sm={12} xl={12} >
                        <Title>Comprovante de Matrícula ou Declaração de Vínculo</Title>
                        <Grid container spacing={3}>
                            <Grid item xs={12} lg={10}>
                                {conteudo}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container style={{ marginTop: 24 }}>
                    <Grid item sm={12}>
                        <ButtonsForm
                            onClick={this.handleSubmit}
                            onBack={this.handleBack}
                            nameOnBack={"Voltar"}
                            idFocus={`saveButton`}
                            loading={this.state.loadingButtonSave}
                            saveDisabled={!isPodeEditarDados}
                        />
                    </Grid>
                </Grid>
                <Grid item sm={12}>
                    <Divider style={{ marginTop: 24 }} />
                </Grid>
                <DialogUploadMatricula
                    parentRef={this.setDialogUploadMatricula}
                    onConfirm={this.handleConfirmUpload}
                    onCancel={this.handleCancelUpload}
                />
                <DialogTrocarEscola
                    parentRef={this.setDialogTrocarEscola}
                    handleConfirm={this.handleDialogTrocarEscolaConfirm}
                />
            </Layout >
        );
    }
}

const mapStateToProps = state => ({ contexts: state.periodos });
const mapDispatchToProps = dispatch => bindActionCreators({ loadPeriodos }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Form));